import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const faqs = [
  {
    q: "Bolu'ya gitmek için en iyi zaman hangisi?",
    a: "Bolu'yu ziyaret etmek için en ideal dönemler Nisan–Haziran ve Eylül–Kasım aylarıdır. İlkbaharda Abant Gölü çevresi ve Yedigöller ormanları çiçek açar, sonbaharda ise Yedigöller'in rengarenk yaprakları eşsiz bir manzara sunar. Kış aylarında (Aralık–Mart) Kartalkaya kayak merkezi aktif olur ve kar manzarası büyüleyicidir.",
  },
  {
    q: "Bolu'da mutlaka görülmesi gereken yerler hangileri?",
    a: "Abant Gölü Tabiat Parkı, Yedigöller Milli Parkı, Kartalkaya Kayak Merkezi, Gölcük Gölü, Mudurnu Osmanlı evleri, Göynük ilçesi ve Bolu Dağı Tüneli çevresi Bolu'nun mutlaka görülmesi gereken yerleri arasındadır. Yedigöller, özellikle Ekim–Kasım aylarında sonbahar renkleriyle Türkiye'nin en güzel doğa manzaralarından birini sunar.",
  },
  {
    q: "Abant Gölü nasıl bir yer ve nasıl gidilir?",
    a: "Abant Gölü, Bolu'ya 34 km uzaklıkta yer alan ve çam ormanlarıyla çevrili doğal bir göldür. Yürüyüş parkurları, bisiklet yolları ve göl kenarındaki restoranlarıyla dört mevsim ziyaret edilebilir. İstanbul'dan TEM otoyolu üzerinden yaklaşık 2,5 saat sürer. Gölün çevresindeki 7 km'lik yürüyüş parkuru oldukça popülerdir.",
  },
  {
    q: "Yedigöller Milli Parkı nedir ve ne zaman gidilmeli?",
    a: "Yedigöller, Bolu'nun Kıbrıscık ilçesine bağlı ve birbirine bağlı 7 gölden oluşan bir milli parktır. Sonbahar aylarında (Ekim–Kasım) sarı, turuncu ve kırmızı yapraklarla kaplanan ormanlar eşsiz bir manzara sunar. Sabah erken saatlerde sis ve yansımalar fotoğraf tutkunları için mükemmel kareler oluşturur. Hafta içi gitmek daha sakin bir deneyim sağlar.",
  },
  {
    q: "Kartalkaya'da kayak yapılabilir mi?",
    a: "Evet, Kartalkaya Türkiye'nin en büyük ve en iyi donanımlı kayak merkezlerinden biridir. İstanbul'a yaklaşık 2,5 saat uzaklıktadır. Kayak sezonu genellikle Aralık–Mart ayları arasındadır. Çok sayıda pist, teleferik ve kayak okulu mevcuttur. Hafta sonları çok kalabalık olduğundan hafta içi tercih edilmesi önerilir; erken rezervasyon şarttır.",
  },
  {
    q: "Bolu'ya İstanbul'dan nasıl gidilir?",
    a: "İstanbul'dan Bolu'ya TEM otoyolu üzerinden araçla yaklaşık 2–2,5 saat sürer. Otobüs seferleri İstanbul Büyük Otogarı'ndan düzenli olarak kalkar ve yaklaşık 2,5 saat sürer. Bolu şehir merkezinden Abant, Yedigöller ve Kartalkaya'ya servis araçları veya araç kiralama ile ulaşılabilir.",
  },
  {
    q: "Mudurnu ve Göynük nasıl yerler?",
    a: "Mudurnu ve Göynük, Bolu'ya bağlı ve Osmanlı döneminden kalma ahşap konak evleriyle ünlü tarihi ilçelerdir. Dar taş sokakları, tarihi çeşmeleri ve geleneksel mimarisiyle zaman yolculuğu hissi yaşatırlar. Göynük, Osmanlı'nın ilk dönemlerine ait tarihi yapılarıyla özellikle dikkat çeker. Her ikisi de hafta sonu kaçamağı için idealdir.",
  },
  {
    q: "Bolu'da ne yenilmeli?",
    a: "Bolu mutfağında öne çıkan lezzetler: Bolu tereyağı (Türkiye'nin en ünlü tereyağlarından biri), Abant alabalığı, Mudurnu'da geleneksel Osmanlı mutfağı, Bolu mantısı ve yöresel mantar yemekleridir. Bolu tereyağı ve yöresel peynirler hediye olarak da çok tercih edilir. Abant Gölü kıyısındaki restoranlarda taze alabalık yemek ayrı bir deneyimdir.",
  },
  {
    q: "Bolu'da kaç gün geçirmek gerekir?",
    a: "Bolu'nun öne çıkan noktalarını görmek için 2–3 gün yeterlidir. İlk gün Abant Gölü ve çevresi, ikinci gün Yedigöller Milli Parkı, üçüncü gün ise Mudurnu veya Göynük tarihi ilçeleri için idealdir. Kış sezonunda Kartalkaya için ayrıca 1–2 gün eklenebilir. Sakarya ve Kocaeli ile birleştirirseniz kapsamlı bir Marmara turu yapabilirsiniz.",
  },
  {
    q: "Bolu'da doğa yürüyüşü için en iyi parkurlar hangileri?",
    a: "Bolu'da en popüler yürüyüş parkurları: Abant Gölü çevresi (7 km, kolay), Yedigöller Milli Parkı (çeşitli güzergahlar, orta zorluk), Gölcük Gölü çevresi (5 km, kolay), Kartalkaya orman yürüyüşleri (yaz) ve Mudurnu çevresi köy yolları. Tüm parkurlar için rahat yürüyüş ayakkabısı ve su taşımanızı öneririz.",
  },
  {
    q: "Bolu'da konaklama seçenekleri nelerdir?",
    a: "Bolu'da konaklama için Abant Gölü kıyısındaki butik oteller ve tatil köyleri, Kartalkaya'daki kayak otelleri, Mudurnu ve Göynük'teki tarihi konak pansiyonları ve Bolu şehir merkezindeki oteller tercih edilebilir. Abant Gölü manzaralı oteller özellikle çiftler için romantik bir seçenektir; kış sezonunda Kartalkaya otelleri için erken rezervasyon şarttır.",
  },
  {
    q: "Bolu'dan günübirlik gezi yapılabilecek yerler var mı?",
    a: "Bolu'dan günübirlik yapılabilecek en popüler destinasyonlar: Sakarya (Taraklı, Acarlar Longozu), Kocaeli (Kartepe, Sapanca), İstanbul (2,5 saat), Ankara (2,5 saat) ve Kastamonu'dur. Bolu'nun merkezi konumu sayesinde Batı Karadeniz ve Marmara Bölgesi'nin pek çok güzel noktasına kolayca ulaşılabilir.",
  },
];

const BoluFaq = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    const title = "Bolu Seyahat SSS — Abant Gölü, Yedigöller ve Kartalkaya Rehberi 2026";
    const desc = "Bolu'ya seyahat planlayanlar için en sık sorulan sorular: Abant Gölü, Yedigöller, Kartalkaya kayak, Mudurnu ve ulaşım hakkında kapsamlı rehber.";
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setCanonical = (url: string) => {
      let el = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", "canonical"); document.head.appendChild(el); }
      el.setAttribute("href", url);
    };
    const injectSchema = (id: string, data: object) => {
      let el = document.getElementById(id);
      if (!el) { el = document.createElement("script"); el.id = id; el.setAttribute("type", "application/ld+json"); document.head.appendChild(el); }
      el.textContent = JSON.stringify(data);
    };

    setCanonical("https://geziturkiyem.com/bolu-sss");
    setMeta("description", desc);
    setMeta("keywords", "bolu seyahat, abant gölü, yedigöller milli parkı, kartalkaya kayak, bolu sss, mudurnu gezilecek yerler, göynük osmanlı evleri, bolu tereyağı, abant alabalığı, bolu doğa yürüyüşü, kartalkaya snowboard, bolu kış tatili, bolu sonbahar, yedigöller sonbahar renkleri, abant gölü yürüyüş parkuru, bolu hafta sonu kaçamak, bolu istanbul yakını, bolu konaklama, abant butik otel, kartalkaya otel rezervasyon, bolu mantar yemekleri, gölcük gölü, bolu kamp alanları, bolu bisiklet, bolu ne zaman gidilir, bolu ulaşım, bolu otobüs, bolu tem otoyolu, batı karadeniz rehberi, bolu günübirlik gezi");
    setMeta("geo.placename", "Bolu");
    setMeta("geo.region", "TR-14");
    setMeta("og:title", title, true);
    setMeta("og:description", desc, true);
    setMeta("og:type", "article", true);
    setMeta("og:url", "https://geziturkiyem.com/bolu-sss", true);
    setMeta("og:image", "https://readdy.ai/api/search-image?query=Yedig%C3%B6ller%20national%20park%20Turkey%20autumn%20fall%20colors%20seven%20lakes%20forest%20reflection%20stunning%20landscape&width=1200&height=630&seq=bol-sss-og&orientation=landscape", true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", desc);

    injectSchema("schema-bolu-faq", {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map((f) => ({
        "@type": "Question",
        "name": f.q,
        "acceptedAnswer": { "@type": "Answer", "text": f.a },
      })),
    });

    injectSchema("schema-bolu-breadcrumb", {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Ana Sayfa", "item": "https://geziturkiyem.com/" },
        { "@type": "ListItem", "position": 2, "name": "Bolu SSS", "item": "https://geziturkiyem.com/bolu-sss" },
      ],
    });

    return () => {
      document.title = "Türkiye Seyahat Rehberi";
      document.getElementById("schema-bolu-faq")?.remove();
      document.getElementById("schema-bolu-breadcrumb")?.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <div className="relative pt-20 pb-16 overflow-hidden bg-stone-900">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Yedig%C3%B6ller%20Turkey%20seven%20lakes%20autumn%20fall%20foliage%20colorful%20forest%20reflection%20misty%20morning%20national%20park&width=1400&height=500&seq=bol-sss-hero&orientation=landscape"
            alt="Bolu Yedigöller"
            className="w-full h-full object-cover object-top opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
        </div>
        <div className="relative max-w-3xl mx-auto px-4 md:px-8 text-center">
          <nav className="flex items-center justify-center gap-2 text-xs text-stone-400 mb-5">
            <Link to="/" className="hover:text-white transition-colors">Ana Sayfa</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-white">Bolu SSS</span>
          </nav>
          <span className="inline-block bg-amber-500/20 border border-amber-400/30 text-amber-300 text-xs font-semibold px-4 py-1.5 rounded-full mb-4 uppercase tracking-widest">
            Sık Sorulan Sorular
          </span>
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            Bolu Seyahat Rehberi
          </h1>
          <p className="text-stone-300 text-sm max-w-xl mx-auto">
            Bolu'ya seyahat planlayanların en çok merak ettiği sorular ve kapsamlı cevapları.
          </p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 md:px-8 py-14">
        {/* Intro */}
        <div className="bg-amber-50 border border-amber-100 rounded-2xl p-6 mb-10">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-xl flex-shrink-0">
              <i className="ri-tree-line text-amber-600 text-xl"></i>
            </div>
            <div>
              <h2 className="font-bold text-stone-900 mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>
                Bolu Hakkında
              </h2>
              <p className="text-stone-600 text-sm leading-relaxed">
                Batı Karadeniz'in kapısı olan Bolu, Abant Gölü'nün huzurlu kıyıları, Yedigöller'in sonbahar renkleri ve Kartalkaya'nın karlı yamaçlarıyla Türkiye'nin en güzel dört mevsim destinasyonlarından biridir. Aşağıda Bolu seyahati hakkında en sık sorulan soruları ve cevaplarını bulabilirsiniz.
              </p>
            </div>
          </div>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`border rounded-2xl overflow-hidden transition-all duration-200 ${
                openIndex === i ? "border-amber-300 bg-amber-50/50" : "border-stone-100 bg-white hover:border-stone-200"
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
              >
                <h4 className={`font-semibold text-sm leading-snug pr-4 ${openIndex === i ? "text-amber-800" : "text-stone-900"}`}>
                  <a id={`sss-${i + 1}`} className="scroll-mt-20">{faq.q}</a>
                </h4>
                <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all ${
                  openIndex === i ? "bg-amber-500 text-white rotate-180" : "bg-stone-100 text-stone-500"
                }`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5">
                  <p className="text-stone-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Related Links */}
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-4">
          <Link to="/sakarya-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-water-flash-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">Sakarya SSS</p>
            <p className="text-xs text-stone-400">Sapanca ve Taraklı rehberi</p>
          </Link>
          <Link to="/kocaeli-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-landscape-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">Kocaeli SSS</p>
            <p className="text-xs text-stone-400">Kartepe ve Kandıra rehberi</p>
          </Link>
          <Link to="/trabzon-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-ship-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">Trabzon SSS</p>
            <p className="text-xs text-stone-400">Karadeniz seyahat rehberi</p>
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default BoluFaq;
